import { ApiEnvironment } from '../../models/api-environment';
import { dataAccessEnvironment } from '../../models/data-access-environment';

export class AuthwsEnvironment extends ApiEnvironment {
  get accountsUrl() {
    return `${this.baseUrl}/api/v1/accounts`;
  }

  get partnersUrl() {
    return `${this.baseUrl}/api/v1/partners`;
  }

  get partnerAccountsUrl() {
    return `${this.baseUrl}/api/v1/partner/accounts`;
  }

  get accountsApplicationUrl() {
    return `${this.baseUrl}/api/v1/accounts/application`;
  }

  get accountsApplicationListUrl() {
    return `${this.baseUrl}/api/v1/accounts/applicationlist`;
  }

  get accountsApplicationSettingsUrl() {
    return `${this.baseUrl}/api/v1/accounts/applicationsettings`;
  }

  get apikeysUrl() {
    return `${this.baseUrl}/api/v1/apikeys`;
  }

  get securityAccountSwitchUrl() {
    return `${this.baseUrl}/api/v1/security/account/switch`;
  }

  get passwordChangeUrl() {
    return `${this.baseUrl}/api/v1/password/change`;
  }

  get passwordResetTokenUrl() {
    return `${this.baseUrl}/api/v1/password/reset-token`;
  }

  get passwordResetTokenEmailUrl() {
    return `${this.baseUrl}/api/v1/password/reset/token`;
  }

  get productsRolesAccountsUrl() {
    return `${this.baseUrl}/api/v1/products/roles/accounts`;
  }

  get productsRolesAccountsV2Url() {
    return `${this.baseUrl}/api/v2/products/roles/accounts`;
  }

  get productsUrl() {
    return `${this.baseUrl}/api/v1/products`;
  }

  get productsV2Url() {
    return `${this.baseUrl}/api/v2/products`;
  }

  get productAssignUrl() {
    return `${this.baseUrl}/api/v1/product/assign`;
  }

  get passwordResetUrl() {
    return `${this.baseUrl}/api/v1/password/reset`;
  }

  get productsMultipleAccountsUrl() {
    return `${this.baseUrl}/api/v1/products/multiple/accounts`;
  }

  get rolesUrl() {
    return `${this.baseUrl}/api/v1/roles`;
  }

  get identityTokenUrl() {
    return `${this.baseUrl}/identity/v2/token`;
  }

  get identityTokenSwitchAccountUrl() {
    return `${this.baseUrl}/identity/v2/token/switchaccount`;
  }

  get securityAuthenticateUrl() {
    return `${this.baseUrl}/api/v2/security/authenticate`;
  }

  get securityLogoutUrl() {
    return `${this.baseUrl}/api/v2/security/logout`;
  }

  get trimbleidAuthenticateUrl() {
    return `${this.baseUrl}/api/v1/trimbleid/authenticate`;
  }

  get securityVerifyUrl() {
    return `${this.baseUrl}/api/v2/security/verify`;
  }

  get usersUrl() {
    return `${this.baseUrl}/api/v1/users`;
  }

  get usersV2Url() {
    return `${this.baseUrl}/api/v2/users`;
  }

  get usersProductsUrl() {
    return `${this.baseUrl}/api/v1/users/${dataAccessEnvironment.authToken}/products`;
  }

  get migrationStatusUrl() {
    return `${this.baseUrl}/api/v1/trimbleid/migration-status`;
  }

  override resolve(environment: unknown) {
    return environment instanceof AuthwsEnvironment ? environment : this;
  }
}

export const authwsEnvironment = new AuthwsEnvironment();
